import { axiosConfig } from './axios-config.js'

export const auth = {
  // 登入
  login: (data) => axiosConfig.post('/api/issue', data),

  // 忘記密碼
  forgotPassword: (data) => axiosConfig.post('/api/forget-password', data),

  // 變更密碼
  changePassword: (data) => axiosConfig.post('/api/reset-password', data),

  // 取得使用者資料
  get: (token) => axiosConfig.get('/api/user', token)

}
